/** @ignore */
// 20201223 - 김상현  default 값을 10에서 50으로 수정
export const LOAD_TEST_RETRY_MAX_COUNT = 50
/** @ignore */
export const LOAD_TEST_RETRY_INTERVAL = 200
